import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { CALL_CONTACT_BUTTON_CLASS_NAME } from './CallContactButton.style'
import {
  revealedRowActionStyle,
  rowActionRevealSelector,
} from './rowActionReveal'

const ContactCardParts = [
  'container',
  'labelContainer',
  'nameText',
  'numberText',
] as const

const helpers = createMultiStyleConfigHelpers(ContactCardParts)
export const ContactCard = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: '5.0625rem',
      width: 'full',
      paddingX: '0.75rem',
      paddingY: '0.5rem',
      gap: '0.5rem',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: 'solid 1px',
      position: 'relative',
      borderColor: 'border.muted',
      _hover: {
        backgroundColor: 'bg.muted',
        borderColor: 'bg.muted',
      },
      _focusWithin: {
        backgroundColor: 'bg.muted',
        borderColor: 'bg.muted',
      },
      [rowActionRevealSelector(CALL_CONTACT_BUTTON_CLASS_NAME)]:
        revealedRowActionStyle,
    },
    labelContainer: {
      flexDirection: 'column',
    },
    nameText: {
      ...textStyles[textStyleKeys.Body1],
    },
    numberText: {
      ...textStyles[textStyleKeys.Body3],
    },
  },
})

export const useContactCardStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactCard, props) as MultiStyleType<
    typeof ContactCardParts
  >
}
